import React, {memo} from "react"
import {useTranslation} from "react-i18next";


import Grid from "@mui/material/Grid";
import FormSection from "../../../components/FormSection";
import Model23Select from "./Model23Select";
import Model23MeasureField from "./Model23MeasureField";
import {formikPropertyChanged} from "./index";


const SnowWeatherData = memo(({formik, model23Registry, inputDisabled}) => {
    const {t} = useTranslation(['models23', 'enums']);

    const snowWeatherDataRegistry = model23Registry.data?.snowWeatherDataRegistry;
    const wwRegistry = snowWeatherDataRegistry?.ww ?? [];
    const vRegistry = snowWeatherDataRegistry?.v ?? [];
    const nRegistry = snowWeatherDataRegistry?.n ?? [];
    const vq1Registry = snowWeatherDataRegistry?.vq1 ?? [];
    const vq2Registry = snowWeatherDataRegistry?.vq2 ?? [];


    const formikPrefix = "snowWeatherData";

    return <FormSection title={t('model23Form.snowWeatherDataTitle')}
                        openDefault={false}
                        error={Boolean(formik.errors.snowWeatherData) && formik.touched.snowWeatherData}>
        <Grid container rowSpacing={3} columnSpacing={4}>
            <Grid item xs={12} md={6}>
                <Model23Select name={`${formikPrefix}.ww`} formik={formik} registry={wwRegistry}
                               disabled={inputDisabled}/>
            </Grid>
            <Grid item xs={6} sx={{display: {xs: "none", md: "block"}}}/>
            <Grid item xs={12} md={6}>
                <Model23Select name={`${formikPrefix}.n`} formik={formik}
                               registry={nRegistry} labelFn={r => `${r.code} - ${r.observation}`}
                               disabled={inputDisabled}/>
            </Grid>
            <Grid item xs={12} md={6}>
                <Model23Select name={`${formikPrefix}.v`} formik={formik} registry={vRegistry}
                               disabled={inputDisabled}/>
            </Grid>
            <Grid item xs={12} md={6}>
                <Model23Select name={`${formikPrefix}.vq1`} formik={formik} registry={vq1Registry}
                               disabled={inputDisabled}/>
            </Grid>
            <Grid item xs={12} md={6}>
                <Model23Select name={`${formikPrefix}.vq2`} formik={formik} registry={vq2Registry}
                               disabled={inputDisabled}/>
            </Grid>
            <Grid item xs={12}>
                <Model23MeasureField name={`${formikPrefix}.ta`} formik={formik} unitOfMeasure="°C" type="number"
                                     disabled={inputDisabled}/>
            </Grid>
            <Grid item xs={12}>
                <Model23MeasureField name={`${formikPrefix}.hs`} formik={formik} unitOfMeasure="cm" type="number"
                                     disabled={inputDisabled}/>
            </Grid>
        </Grid>
    </FormSection>
}, (prevProps, nextProps) => formikPropertyChanged(prevProps, nextProps, 'snowWeatherData') && prevProps.model23Registry === nextProps.model23Registry);

export default SnowWeatherData;